import { Route, Routes, Navigate } from 'react-router-dom';

import Details from 'src/features/routes/profile/Details';
import Email from 'src/features/routes/profile/Email';
import Password from 'src/features/routes/profile/Password';
import Settings from 'src/features/routes/profile/Settings';

const ProfileRoutes = () => {
    return (
        <Routes>
            <Route path="" element={<Details />} />
            <Route path="email" element={<Email />} />
            <Route path="password" element={<Password />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    );
};

export default ProfileRoutes;
